import { getPhoneNumberDetails } from "./phoneNumber.helper";

export const isIndianCustomer = (agent) => {
  try {
    if (agent.country) return agent.country === "India";
    if (agent.countryCode) return agent.countryCode === "+91";
    const parsedPhoneNumber = getPhoneNumberDetails(
      agent.contact,
      agent.countryCode || "+91",
      agent.country,
      agent.isoCode
    );

    return parsedPhoneNumber.country === "IN";
  } catch (error) {
    return false;
  }
};